import { useMemo } from "react";
import { checkPermission, checkPermissions } from "@shared/utils";
import { useSelector } from "react-redux";
import { selectors } from "@shared/store";
import type { PERMISSION } from "@shared/constants";

function useCheckPermission(permission?: PERMISSION | PERMISSION[]): boolean {
  const user = useSelector(selectors.getUserDetails());

  const permitted = useMemo(() => {
    if (!user) return false;
    if (!permission) return true;
    return Array.isArray(permission) ? checkPermissions(permission, user) : checkPermission(permission, user);
  }, [permission, user]);

  return permitted;
}

export default useCheckPermission;
